module.exports = __webpack_public_path__ + "media/images/loading-0fee75ef53c0fe315442c1fcc9cdf345.svg";